export const initialCursoForm = {
  nombre: "",
  codigo_curso: "",
  centro_id: "",
  nivel_id: "",
  especialidad_id: "",
  duracion_horas: "",
  precio_base: "",
  monto_min_reserva: "",
  monto_matricula: "",
  monto_comision: "",
  activo: true,
  es_reentrenamiento: false,
  requiere_examen: false,
  curso_oficial_id: "",
};

export const initialCursosFilters = {
  search: "",
  centro_id: "",
  nivel_id: "",
  activo: "all",
};

export const validateCursoForm = (form) => {
  if (!form.nombre?.trim()) return "El nombre del curso es obligatorio.";
  if (!form.codigo_curso?.trim()) return "El codigo del curso es obligatorio.";
  if (!form.centro_id) return "Selecciona un centro educativo.";
  if (form.duracion_horas === "" || form.duracion_horas === null || Number.isNaN(Number(form.duracion_horas))) {
    return "Ingresa la duracion en horas del curso.";
  }
  if (Number(form.duracion_horas) <= 0) return "La duracion en horas debe ser mayor a 0.";
  if (form.precio_base === "" || form.precio_base === null || Number.isNaN(Number(form.precio_base))) {
    return "Ingresa el precio base del curso.";
  }
  return null;
};
